import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllApprovalLikelihoodsEndpoint } from "~/modules/project/api/approvalLikelihood/approvalLikelihoodApiEndpoints.ts";
import type { ApprovalLikelihood } from "~/modules/project/api/approvalLikelihood/approvalLikelihoodTypes.ts";

export const getAllApprovalLikelihoods = (): AxiosApiResponsePromise<ApprovalLikelihood[]> => axiosApi.get(getAllApprovalLikelihoodsEndpoint);
